import axios from 'axios';

const uapi = localStorage.getItem("uapi") || "uapi";
const apiBet = axios.create({
  baseURL: "https://" + uapi + process.env.REACT_APP_API_BET,
  headers: { 'Content-Type': "application/json" }
});


export default apiBet